<template>
    <v-card
            class="mx-auto"
            outlined
            :color="colors.quadrant[quadrant]"
    >
        <v-toolbar
                flat
                :color="colors.quadrant[quadrant]"
                dark
        >
            <v-toolbar-title>
                {{ radar['quadrant_' + quadrant] }}
            </v-toolbar-title>
            <v-spacer></v-spacer>

            <v-tooltip
                top
                open-delay="tooltipDelay"
                v-if="!active"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        @click="$emit('openQuadrant')"
                    >
                        <v-icon>mdi-magnify-plus-outline</v-icon>
                    </v-btn>
                </template>
                <span>{{ $t('controls.tooltip.open_quadrant') }}</span>
            </v-tooltip>

            <v-tooltip
                    top
                    open-delay="tooltipDelay"
                    v-else
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-bind="attrs"
                        v-on="on"
                        icon
                        @click="back"
                    >
                        <v-icon>mdi-radar</v-icon>
                    </v-btn>
                </template>
                <span>{{ $t('controls.tooltip.back_radar') }}</span>
            </v-tooltip>

            <BlobFormDialog :blob="{ quadrant: quadrant, radar_id: radar.id }" v-if="isOwner"></BlobFormDialog>
        </v-toolbar>
        <v-list v-if="quadrantBlobs.length <= 0">
            <v-list-item>
                {{ $t('blob.list.empty') }}
            </v-list-item>
        </v-list>
        <v-list
            v-else
            two-line
        >
            <v-list-item-group v-model="activeBlob">
                <template
                        v-for="(blob, i) in quadrantBlobs"
                >

                    <v-divider
                        :key="i+'_line'"
                        v-if="i > 0"
                    ></v-divider>
                    <v-hover
                        :key="blob.id"
                        v-slot:default="{ hover }"
                    >
                        <v-list-item

                                :class="blob.id === highlightBlobId ? 'active' : ''"
                                @click="openBlob(blob)"
                                @mouseenter="highlight(blob.id)"
                                @mouseleave="removeHighlight()"
                        >
                            <v-list-item-icon>
                                <v-icon :color="hover? colors.quadrant[quadrant]: 'grey lighten-1'">mdi-image-filter-tilt-shift</v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                                <v-list-item-title
                                    v-text="blob.name"
                                ></v-list-item-title>
                                <v-list-item-subtitle
                                    class="font-weight-thin"
                                >
                                    <v-icon size="medium">mdi-update</v-icon>
                                    {{ blob.updated_at|formatDateTime }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action v-if="blob.entries.length > 0">
                                <v-badge
                                    bordered
                                    overlap
                                    :color="colors.quadrant[quadrant]"
                                    :content="blob.entries.length"
                                >
                                    <v-icon>
                                        mdi-message-outline
                                    </v-icon>
                                </v-badge>
                            </v-list-item-action>
                        </v-list-item>
                    </v-hover>
                </template>
            </v-list-item-group>
        </v-list>
    </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  import BlobFormDialog from './BlobFormDialog'
  import { settings, canvas } from '../../settings/settings.js'

  export default {
    name: 'BlobList',
    components: { BlobFormDialog },
    props: {
      radar: {
        type: Object,
        required: true
      },
      quadrant: {
        type: Number,
        required: true
      },
      active: {
        type: Boolean,
        default: true
      }
    },

    computed: {
      ...mapGetters({
        userId: 'user/userId',
        highlightBlobId: 'blobs/getHighlightBlobId'
      }),

      isOwner() {
        return this.radar.owner_id === this.userId
      },

      blobs () {
        return this.$store.getters['blobs/getRadarBlobs'](this.radar.id)
      },

      quadrantBlobs () {
        return this.blobs.filter(b => b.quadrant == this.quadrant)
      },

      activeBlob: {
        set () {

        },
        get () {
          return this.quadrantBlobs.findIndex(b => b.id === this.highlightBlobId)
        }
      }
    },

    data: () => ({
      ...settings,
      ...canvas
    }),

    methods: {
      back () {
        this.$emit('openRadar')
      },
      openBlob (blob) {
        this.$router.push({ name: 'blob', params: { blobId: blob.id } }).catch(() => {})
        // this.$store.commit('blobs/setCurrentBlobId', blob.id)
      },
      highlight (id) {
        this.$store.commit('blobs/setHighlightBlobId', id)
      },
      removeHighlight () {
        this.$store.commit('blobs/clearHighlightBlobId')
      }
    }
  }
</script>
